<template>
    <div class="container-center">

        <el-form class="msg-form" label-width="140px" ref="form" :model="form" :rules="rules">
            <el-row>
                <el-col :span="10">
                    <el-form-item label="消息内容：" prop="name">
                        <el-input size="medium" v-model="form.content" clearable></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="2" :offset="1">
                    <el-button type="warning" class="btn-theme" size="medium" @click="getListByTab(segmentActive)" icon="el-icon-search">搜索</el-button>
                </el-col>
            </el-row>
        </el-form>

        <el-tabs v-model="segmentActive" type="border-card" @tab-click="handleTabClick" class="tabs-margin" v-loading="tabLoading">
            <el-tab-pane :name="'tab01'">
                <span slot="label">招投标类</span>
                <div class="msg-list-box">
                    <div class="no-data-tip" v-if="msgList.length == 0"></div>
                    <el-row v-else class="msg-list" v-for="(li,index) in msgList" :key="index">
                        <el-col :span="4" class="text-center">{{ li.msgTypeName }}</el-col>
                        <el-col :span="17">
                            <router-link :to="{name:'MsgDetail',params:{ id:li.id }}" >{{ li.content }}</router-link>
                            <el-tag type="warning" size="mini">{{ ['未读','已读'][li.readFlag] }}</el-tag>
                        </el-col>
                        <el-col :span="3" class="text-right">{{ li.sendTime }}</el-col>
                    </el-row>
                </div>
                <div class="block">
                    <el-pagination
                        @current-change="(val)=>{handleCurrentChange(val,'pager')}"
                        :page-size="pager.pageSize"
                        :current-page="pager.pageNum"
                        :total="pager.total"
                        prev-text="上一页"
                        next-text="下一页"
                        layout="total, prev, pager, next"
                        background>
                    </el-pagination>
                </div>
            </el-tab-pane>

            <el-tab-pane :name="'tab02'">
                <span slot="label">工程管理类</span>
                <div class="msg-list-box">
                    <div class="no-data-tip" v-if="msgList2.length == 0"></div>
                    <template v-else>
                        <el-row class="msg-list" v-for="(li,index) in msgList2" :key="index">
                            <el-col :span="4" class="text-center">{{ li.msgTypeName }}</el-col>
                            <el-col :span="17">
                                <router-link :to="{name:'MsgDetail',params:{ id:li.id }}" >{{ li.content }}</router-link>
                                <el-tag type="warning" size="mini">{{ ['未读','已读'][li.readFlag||0] }}</el-tag>
                            </el-col>
                            <el-col :span="3" class="text-right">{{ li.sendTime }}</el-col>
                        </el-row>
                    </template>
                </div>
                <div class="block">
                    <el-pagination
                            @current-change="(val)=>{handleCurrentChange(val,'pager2')}"
                            :page-size="pager2.pageSize"
                            :current-page="pager2.pageNum"
                            :total="pager2.total"
                            prev-text="上一页"
                            next-text="下一页"
                            layout="total, prev, pager, next"
                            background>
                    </el-pagination>
                </div>
            </el-tab-pane>

             <el-tab-pane :name="'tab03'">
                <span slot="label">客服类</span>
                <div class="msg-list-box">
                    <div class="no-data-tip" v-if="msgList3.length == 0"></div>
                    <template v-else>
                        <el-row class="msg-list" v-for="(li,index) in msgList3" :key="index">
                            <el-col :span="4" class="text-center">{{ li.msgTypeName }}</el-col>
                            <el-col :span="17">
                                <router-link :to="{name:'MsgDetail',params:{ id:li.id }}" >{{ li.content }}</router-link>
                                <el-tag type="warning" size="mini">{{ ['未读','已读'][li.readFlag||0] }}</el-tag>
                            </el-col>
                            <el-col :span="3" class="text-right">{{ li.sendTime }}</el-col>
                        </el-row>
                    </template>
                </div>
                <div class="block">
                    <el-pagination
                            @current-change="(val)=>{handleCurrentChange(val,'pager3')}"
                            :page-size="pager3.pageSize"
                            :current-page="pager3.pageNum"
                            :total="pager3.total"
                            prev-text="上一页"
                            next-text="下一页"
                            layout="total, prev, pager, next"
                            background>
                    </el-pagination>
                </div>
            </el-tab-pane>
        </el-tabs>


    </div><!-- container-center -->
</template>

<script type="text/babel">
import banner from '@/assets/imgs/banner_invite.png'
import util from '@/util'

export default {
    name: 'msg-list',
    data () {
        return {
            rules: {},
            tabLoading:false,
            segmentActive: '',
            form: {
                content: ''
            },
            msgList: [],
            pager:{
                total: 0,
                pageNum: 1,
                pageSize: 10
            },
            msgList2: [],
            pager2:{
                total: 0,
                pageNum: 1,
                pageSize: 10
            },
            msgList3:[],
            pager3:{
                total: 0,
                pageNum: 1,
                pageSize: 10
            },

        }
    },
    methods: {
        handleTabClick(tab, event){
            this.resetPagination();
            this.segmentActive = tab.name;
            this.getListByTab(this.segmentActive);
        },

        getMobileMsgList () {
            this.$http.post('rest/api/supplierHomepage/getMobileMsg',{
                pageNum: this.pager.pageNum,
                pageSize: this.pager.pageSize,
                stockId: this.$root.stockId,
                content: this.form.content
            }).then((res)=>{
                if(res.data.result) {
                    this.tabLoading = false;
                    this.msgList = res.data.value.list;
                    this.pager.total = res.data.value.totalCount;
                }
            })

        },

        handleCurrentChange (page,key) {
            util.toTop();
            this[key].pageNum = page;
            this.getListByTab(this.segmentActive);
        },

        getListByTab(tab){
            let resultFn = {
                'tab01': this.getMobileMsgList.bind(this),
                'tab02': ()=>{
                    this.getMsgList({type:'3',pageNum: this.pager2.pageNum,pageSize: this.pager2.pageSize}).then(data =>{
                        this.tabLoading = false;
                        if(data.data.result){
                            this.msgList2 = data.data.value.list || [];
                            this.pager2.total = data.data.value.count || 0;
                        }
                    })
                },
                'tab03': ()=>{
                    this.getMsgList({type:'7',pageNum: this.pager3.pageNum,pageSize: this.pager3.pageSize}).then(data =>{
                        this.tabLoading = false;
                        if(data.data.result){
                            this.msgList3 = data.data.value.list || [];
                            this.pager3.total = data.data.value.count || 0;
                        }
                    })
                },
            }[tab]
            resultFn ? (resultFn(),this.tabLoading = true) : null;
        },

        getMsgList(opt) {
            let baseParams = {
                userId: this.$root.userId,
                content: this.form.content
            }
            return this.$http.post('rest/api/noticeApi/getNoticeList',Object.assign(baseParams,opt))
        },

        resetPagination(){
            this.pager.pageSize = 10;
            this.pager.pageNum = 1;
            this.pager2.pageSize = 10;
            this.pager2.pageNum = 1;
            this.pager3.pageSize = 10;
            this.pager3.pageNum = 1;
        },

    },
    created(){
        this.$root.navs = [{name:'我的消息',path:'/msgList'}];
        this.$root.headImage.src = banner;
        let type = this.$route.params.type || 'invite';
        this.segmentActive = {
            'invite':'tab01',
            'project': 'tab02',
            'customer': 'tab03'
        }[type]
        this.resetPagination();
        this.getListByTab(this.segmentActive)
    },
    mounted () {
    }
}

</script>

<style scoped lang="postcss">
@import '../../../assets/common.css';

.clearfix:after {display: table;content: " ";clear: both;}

.msg-form {background: #F5F6F5;padding: 25px 10px 10px 10px;margin: 24px 0;}

.tabs-margin {margin:20px 0 40px 0;}

.msg-list-box {font-size:14px;}
.msg-list {width: 100%;border-bottom: 1px solid #E4E5E4;padding:8px 0;}
.msg-list {font-size: 14px;margin:0;line-height:28px;}
.msg-list a {color: #000;text-decoration: none;}
.msg-list a:hover {color: var(--cMain);}


</style>



// WEBPACK FOOTER //
// src/pages/dsp/home/MsgList.vue